import { useTranslation } from 'react-i18next';
import { AvatarName, Chip, ChipProps } from '../..';

export type TransactionCategoryChipProps = ChipProps<'div', { category: string }>;

export function TransactionCategoryChip({ category, ...props }: TransactionCategoryChipProps) {
  const { t } = useTranslation('transactionCategory');
  const name = t(category, { defaultValue: category });

  return <Chip {...props} label={name} avatar={<AvatarName name={name} />} />;
}
